
import { CacheTypenames } from '@workbench-stack/core';

// populate cache as empty array as initially
export const defaults = {
    Context: {
        resourceScheme: '',
        resourceFilename: '',
        resourceLangId: '',
        resource: '',
        resourceExtName: '',
        resourceSet: '',
        isFileSystemResource: '',
        originalResourceScheme: '',
        view: '',
        viewItem: '',
        gitOpenRepositoryCount: '',
        isInDiffEditor: '',
        isInDiffRightEditor: '',
        inputFocus: '',
        suggestWidgetVisible: '',
        suggestWidgetMultipleSuggestions: '',
        suggestionMakesTextEdit: '',
        acceptSuggestionOnEnter: '',
        hasOtherSuggestions: '',
        groupFocusedInOpenEditors: '',
        dirtyEditor: '',
        resourceSelectedForCompare: '',
        fileCopied: '',
        breadcrumbsPossible: '',
        breadcrumbsVisible: '',
        breadcrumbsActive: '',
        canNavigateBack: '',
        canNavigateForward: '',
        canNavigateToLastEditLocation: '',
        dirtyDiffVisible: '',
        cancellableOperation: '',
        parameterHintsVisible: '',
        parameterHintsMultipleSignatures: '',
        markdownPreviewFocus: '',
        isMac: '',
        isLinux: '',
        isWindows: '',
        remoteAuthority: '',
        remoteConnectionState: '',
        hasMacNativeTabs: '',
        supportsWorkspaces: '',
        isDevelopment: '',
        workbenchState: '',
        workspaceFolderCount: '',
        remoteFileDialogVisible: '',
        isFullscreen: '',
        atEndOfWord: '',
        scmRepository: '',
        scmProvider: '',
        scmResourceGroup: '',
        inDiffEditorKey: '',
        isDominatedByLongLines: '',
        isWordWrapMinified: '',
        commentThread: '',
        commentThreadisEmpty: '',
        commentIsEmpty: '',
        commentEditorFocused: '',
        interfaceOverviewVisible: '',
        inReferenceSearchEditor: '',
        referenceSearchVisible: '',
        listFocus: '',
        listSupportsMultiSelect: '',
        listHasSelectionOrFocus: '',
        listDoubleSelection: '',
        listMultiSelection: '',
        listSupportsKeyboardNavigation: '',
        WorkbenchListAutomaticKeyboardNavigationKey: '',
        accessibilityHelpWidgetVisible: '',
        inQuickOpenKey: '',
        supportedCodeAction: '',
        hasSymbols: '',
        hasSnippetCompletions: '',
        messageVisible: '',
        editorHasCallHierarchyProvider: '',
        callHierarchyVisible: '',
        searchViewletVisible: '',
        searchViewletFocus: '',
        inputBoxFocus: '',
        searchInputBoxFocus: '',
        replaceInputBoxFocus: '',
        patternIncludesInputBoxFocus: '',
        patternExcludesInputBoxFocus: '',
        replaceActive: '',
        hasSearchResult: '',
        firstMatchFocus: '',
        fileMatchOrMatchFocus: '',
        fileMatchOrFolderMatchFocus: '',
        fileMatchFocus: '',
        folderMatchFocus: '',
        matchFocus: '',
        inRecentFilesPicker: '',
        inWindowsPicker: '',
        findWidgetVisible: '',
        findInputFocussed: '',
        replaceInputFocussed: '',
        editorTextFocus: '',
        editorFocus: '',
        textInputFocus: '',
        editorReadonly: '',
        editorHasSelection: '',
        editorHasMultipleSelections: '',
        editorTabMoveFocus: '',
        isInEmbeddedEditor: '',
        canUndo: '',
        canRedo: '',
        editorLangId: '',
        editorHasCompletionItemProvider: '',
        editorHasCodeActionsProvider: '',
        editorHasDefinitionProvider: '',
        editorHasDeclarationProvider: '',
        editorHasImplementationProvider: '',
        editorHasTypeDefinitionProvider: '',
        editorHasHoverProvider: '',
        editorHadDocumentHighlightProvider: '',
        editorHasDocumentSymbolProvider: '',
        editorHasReferenceProvider: '',
        editorHasRenameProvider: '',
        editorHasSignatureHelpProvider: '',
        editorHasDocumentFormattingProvider: '',
        editorHasDocumentSelectionFormattingProvider: '',
        editorHasMultipleDocumentSelectionFormattingProvider: '',
        activeEditor: '',
        editorIsOpen: '',
        editorPinned: '',
        groupActiveEditorDirty: '',
        groupEditorsCount: '',
        textCompareEditorVisible: '',
        textCompareEditorActive: '',
        activeEditorGroupEmpty: '',
        multipleEditorGroups: '',
        inZenMode: '',
        inCenteredLayout: '',
        splitEditorsVertically: '',
        sideBarVisible: '',
        sideBarFocus: '',
        activeViewlet: '',
        activePanel: '',
        panelFocus: '',
        panelPosition: '',
        debugType: '',
        debugConfigurationType: '',
        debugState: '',
        inDebugMode: '',
        inDebugRepl: '',
        breakpointWidgetVisible: '',
        watchExpressionsFocused: '',
        variablesFocused: '',
        expressionSelected: '',
        breakpointSelected: '',
        callStackItemType: '',
        loadedScriptsSupported: '',
        loadedScriptsItemType: '',
        focusedSessionIsAttach: '',
        stepBackSupported: '',
        restartFrameSupported: '',
        inSettingsEditor: '',
        inSettingsJSONEditor: '',
        inSettingsSearch: '',
        settingsTocRowFocus: '',
        inKeybindings: '',
        inKeybindingsSearch: '',
        keybindingFocus: '',
        explorerViewletVisible: '',
        explorerResourceIsFolder: '',
        explorerResourceReadonly: '',
        explorerResourceIsRoot: '',
        explorerResourceCut: '',
        explorerResourceMoveableToTrash: '',
        filesExplorerFocus: '',
        openEditorsVisible: '',
        openEditorsFocus: '',
        explorerViewletFocus: '',
        terminalIsOpen: '',
        terminalFocus: '',
        terminalTextSelected: '',
        terminalFindWidgetVisible: '',
        terminalFindWidgetInputFocused: '',
        terminalFindWidgetFocused: '',
        webviewFindWidgetVisible: '',
        taskRunning: '',
        referenceSearchTreeFocused: '',
        interactivePlaygroundFocus: '',
        outlineFiltered: '',
        outlineFocused: '',
        problemsViewFocus: '',
        problemFocus: '',
        problemsFilterFocus: '',
        relatedInformationFocus: '',
        inOutput: '',
        activeLogOutput: '',
        multiCursorModifier: '',
        saveConflictResolutionContext: '',
        markersNavigationVisible: '',
        hasWordHighlights: '',
        profileSessionState: '',
        extensionHostProfileRecorded: '',
        historyNavigationEnabled: '',
        historyNavigationWidget: '',
        nonEmptyWorkspace: '',
        defaultExtensionViews: '',
        searchMarketplaceExtensions: '',
        searchInstalledExtensions: '',
        searchOutdatedExtensions: '',
        searchEnabledExtensions: '',
        searchDisabledExtensions: '',
        hasInstalledExtensions: '',
        searchBuiltInExtensions: '',
        recommendedExtensions: '',
        defaultRecommendedExtensions: '',
        workspaceRecommendations: '',
        workspaceFolderRecommendations: '',
        addToWorkspaceRecommendations: '',
        addToWorkspaceFolderRecommendations: '',
        __typename: CacheTypenames.Context,
    },
};

